import axios from 'axios';
import {KRBS_TONS} from '../../config/constanst.config';
import {AlertService} from '../../service/alert.service';

const initFileHistories = () => {
  return {
    crewTonFileHistory: {},
    crewTonFileHistories: [],
  };
};

/** state **/
const state = {
  ...initFileHistories(),
};

/** mutations **/
const mutations = {
  set_ton_file_history(state, payload) {
    state.crewTonFileHistory = payload;
  },

  set_ton_file_histories({commit}, payload) {
    state.crewTonFileHistories = payload;
  },

  delete_ton_file_history(state, payload) {
    //crewTonFileHistoryId
    // console.log('deleting this 123', payload);
    let index = state.crewTonFileHistories.findIndex(
        (v, k) => v.crewTonFileHistoryId === payload.crewTonFileHistoryId);
    state.crewTonFileHistories.splice(index, 1);
  },

  reset_file_history_vuex(state) {
    Object.assign(state, initFileHistories());
  },
};

/** actions **/
const actions = {

  setTonFileHistory(state, payload) {
    commit('set_ton_file_history', payload);
  },

  setTonFileHistories({commit}, payload) {
    commit('set_ton_file_histories', payload);
  },

  deleteTonFileHistory({commit}, payload) {
    return axios.delete(KRBS_TONS.STAFF_DELETE_TON_FILE_HISTORY, payload).then((r) => {
      commit('delete_ton_file_history', r.data);
      return true;

    }).catch((er) => {
      AlertService.responseAlertMessage(er, 'Delete file history');
      return false;

    });
  },

  downloadFileHistory({commit}, payload) {
    return axios.post(KRBS_TONS.STAFF_DOWNLOAD_TON_FILE_HISTORY, payload, {
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        commit('set_download_percent', percentComplete);
      },

    }).then((r) => {
      const url = URL.createObjectURL(new Blob([r.data], {
        type: r.data.type,
      }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `TON_${payload.createdAt}`);
      document.body.appendChild(link);
      link.click();
      commit('set_download_percent', 0);
      return true;

    }).catch((er) => {
      commit('set_download_percent', 0);
      AlertService.responseAlertMessage(er, 'Download file history');
      return false;

    });
  },

  resetFileHistoryVuex({commit}) {
    commit('reset_file_history_vuex');
  },
};

/** getters **/
const getters = {
  crewTonFileHistory: state => state.crewTonFileHistory,
  crewTonFileHistories: state => state.crewTonFileHistories,

};

/** export **/
export default {state, actions, mutations, getters};
